import { DateFormatter } from '@repo/toolkit/date'
import { useMutation } from '@tanstack/react-query'

import { generateTripFolderPdf } from '../../../api/trip-folder/generate-pdf'
import { TripFolderPdfInput } from '../../../lib/types/models/trip-folder/trip-folder'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { mapTripFolderPDFFormInputToInput } from './trip-folder.utils'
import { TripFolderPdfForm } from './trip-folder-pdf-form'

interface TripFolderCreateTransferProps {
  tripFolderId: number
  className?: string
  toggleModal: () => void
}

export function TripFolderGeneratePdf({
  tripFolderId,
  toggleModal,
  className
}: TripFolderCreateTransferProps) {
  const { mutateAsync } = useMutation({
    mutationFn: (data: TripFolderPdfInput) =>
      generateTripFolderPdf(tripFolderId, {
        ...data,
        printDate: DateFormatter.ddMMYYYY_HHMM(new Date())
      }),
    onSuccess: () => {
      toggleModal()
    },
    onError: showAxiosError
  })

  return (
    <div className={className}>
      <TripFolderPdfForm
        tripFolderId={tripFolderId}
        className={className}
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (data) => mutateAsync(mapTripFolderPDFFormInputToInput(data)),
          onCancel: toggleModal,
          confirmText: 'Imprimer',
          cancelText: 'Fermer'
        })}
      />
    </div>
  )
}
